export default __webpack_public_path__ + "9baad1d6da68cc2657eb1340486db7f8.png";